import { LinkedInMarketingDashboard } from "@/components/marketing/LinkedInMarketingDashboard";

export default function Marketing() {
  return <LinkedInMarketingDashboard />;
}